module.exports = __webpack_public_path__ + "static/media/PushtimargImage25.b3c9e287.jpg";